/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum FilterOperation {
    In = 'in',
    Contains = 'contains',
    Subset = 'subset',
    Superset = 'superset',
    Equals = 'equals',
    NotEquals = 'notEquals',
    LessThan = 'lessThan',
    LessThanOrEqual = 'lessThanOrEqual',
    GreaterThan = 'greaterThan',
    GreaterThanOrEqual = 'greaterThanOrEqual',
}
